import { useState } from 'react';
import axios from 'axios';

import { getUserRoleFromToken } from '../utils/getUserRoleFromToken';

const token = localStorage.getItem("token");
const userRole = getUserRoleFromToken(token);
const isAdmin = userRole === "admin";


function LoginPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    try {
      const res = await axios.post('/api/auth/login', { email, password });
      localStorage.setItem('token', res.data.token);
      window.location.href = '/';
    } catch (err) {
      setError(err.response?.data?.message || 'Login failed');
    }
  };

  return (
    <div className="flex h-screen justify-center items-center bg-gray-100">
      <form className="bg-white shadow-lg p-8 rounded-xl w-96" onSubmit={handleSubmit}>
        <h2 className="text-2xl font-bold mb-6 text-center">Login</h2>
        {error && <div className="mb-4 text-red-600 text-center">{error}</div>}
        <div className="mb-4">
          <label className="block text-gray-700 mb-1">Email</label>
          <input
            className="w-full border rounded p-2"
            type="email"
            required
            value={email}
            onChange={e => setEmail(e.target.value)}
            autoFocus
          />
        </div>
        <div className="mb-6">
          <label className="block text-gray-700 mb-1">Password</label>
          <input
            className="w-full border rounded p-2"
            type="password"
            required
            value={password}
            onChange={e => setPassword(e.target.value)}
          />
        </div>
        <button className="w-full bg-blue-600 hover:bg-blue-700 text-white py-2 rounded transition" type="submit">
          Login
        </button>
      </form>
    </div>
  );
}

export default LoginPage;
